export const alertConstants = {
    SUCCESS: 'success',
    ERROR: 'error',
    CLEAR: 'clear',
    FAILURE: 'warning',
    INFO: 'info',
    WARNING: 'warning',
    UNVERIFIED: 'unverified',
};
